import { useParams, Link, Navigate } from "react-router-dom";
import { KNOWLEDGE } from "@/lib/content";
import { ArrowLeft, ArrowRight, ArrowUpRight } from "@phosphor-icons/react";

export default function KnowledgeArticle() {
  const { slug } = useParams();
  const idx = KNOWLEDGE.findIndex((k) => k.slug === slug);
  if (idx < 0) return <Navigate to="/knowledge" replace />;
  const k = KNOWLEDGE[idx];
  const next = KNOWLEDGE[(idx + 1) % KNOWLEDGE.length];

  return (
    <>
      <section className="bg-[var(--pta-cream)] pt-16 md:pt-24 pb-10" data-testid="knowledge-article">
        <div className="max-w-[900px] mx-auto px-6 md:px-10">
          <Link data-testid="back-knowledge" to="/knowledge" className="inline-flex items-center gap-2 font-mono-fine text-[11px] tracking-[0.24em] uppercase text-[var(--pta-navy)] hover:text-[var(--pta-gold)]">
            <ArrowLeft size={14} /> All notes
          </Link>
          <div className="mt-8 flex items-center gap-4">
            <span className="font-mono-fine text-[10px] tracking-[0.22em] uppercase text-[var(--pta-gold)] border hairline-gold px-2 py-1">{k.tag}</span>
            <span className="font-mono-fine text-[10px] tracking-[0.22em] uppercase text-[var(--pta-ink)]/50">{k.date}</span>
            <span className="font-mono-fine text-[10px] tracking-[0.22em] uppercase text-[var(--pta-ink)]/50">· {k.read}</span>
          </div>
          <h1 className="mt-6 font-serif-display text-4xl md:text-6xl leading-[1.02] text-[var(--pta-navy)]">{k.title}</h1>
          <p className="mt-6 font-serif-display italic text-xl md:text-2xl text-[var(--pta-gold)]">{k.excerpt}</p>
        </div>
      </section>

      <article className="bg-[var(--pta-cream)] pb-16">
        <div className="max-w-[760px] mx-auto px-6 md:px-10 space-y-6 font-serif-display text-lg leading-relaxed text-[var(--pta-ink)]/85">
          {k.body.map((p, i) => (
            <p key={i} data-testid={`article-para-${i}`}>{p}</p>
          ))}
        </div>
      </article>

      <section className="bg-[var(--pta-paper)] py-14">
        <div className="max-w-[760px] mx-auto px-6 md:px-10">
          <div className="chapter-num">Further reading</div>
          <h3 className="font-serif-display text-3xl text-[var(--pta-navy)] mt-3">Primary sources & references.</h3>
          <ul className="mt-6 divide-y hairline border-t hairline">
            {k.resources.map((r, i) => (
              <li key={i}>
                <a
                  data-testid={`resource-${i}`}
                  href={r.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-between py-4 group"
                >
                  <span className="font-serif-display text-lg text-[var(--pta-navy)] group-hover:text-[var(--pta-gold)] transition-colors">{r.label}</span>
                  <ArrowUpRight size={18} weight="bold" className="text-[var(--pta-navy)]/60 group-hover:text-[var(--pta-gold)]" />
                </a>
              </li>
            ))}
          </ul>
          <p className="mt-6 text-xs text-[var(--pta-ink)]/50">Links open on official portals (CBIC / ICAI / MCA / SEBI / others). For an application-specific opinion, book a consultation.</p>
        </div>
      </section>

      <section className="section-dark py-16">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 flex flex-col md:flex-row items-start md:items-end justify-between gap-6">
          <div>
            <div className="chapter-num">Next read</div>
            <Link data-testid="next-article" to={`/knowledge/${next.slug}`} className="font-serif-display text-3xl md:text-5xl text-[var(--pta-cream)] hover:text-[var(--pta-gold)] block mt-3">
              {next.title} <ArrowRight className="inline" size={24} weight="bold" />
            </Link>
          </div>
          <Link data-testid="article-cta" to="/book" className="btn-pta-gold">Book Consultation</Link>
        </div>
      </section>
    </>
  );
}
